import { render, staticRenderFns } from "./reparations.pug?vue&type=template&id=3c470824&lang=pug&external"
import script from "./reparations.js?vue&type=script&lang=js&external"
export * from "./reparations.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c470824')) {
      api.createRecord('3c470824', component.options)
    } else {
      api.reload('3c470824', component.options)
    }
    module.hot.accept("./reparations.pug?vue&type=template&id=3c470824&lang=pug&external", function () {
      api.rerender('3c470824', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/reparations/index.vue"
export default component.exports